import {
  IncomingReviewListCycle,
  OutgoingGetReviewListProps,
  IncomingReviewList,
  IncomingReviewListDesignation,
} from '../../../../types/Performance/ReviewList/reviewListTypes'
import {
  getAuthenticatedRequestConfig,
  useAxios,
} from '../../../../utils/apiUtils'
import { AllowedHttpMethods, reviewListApiConfig } from '../../apiList'

const getActiveCycle = async (): Promise<IncomingReviewListCycle | string> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: reviewListApiConfig.activeCycle,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getCycles = async (): Promise<IncomingReviewListCycle[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: reviewListApiConfig.getAppraisalCycles,
    method: AllowedHttpMethods.get,
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getDesignations = async (
  deptId: number,
): Promise<IncomingReviewListDesignation[]> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: reviewListApiConfig.getDesignations,
    method: AllowedHttpMethods.get,
    params: {
      deptId,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const getReviewList = async (
  finalData: OutgoingGetReviewListProps,
): Promise<IncomingReviewList> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: reviewListApiConfig.getReviewList,
    method: AllowedHttpMethods.post,
    data: {
      ...finalData,
    },
  })
  const response = await useAxios(requestConfig)
  return response.data
}

const exportReviewList = async (
  props: OutgoingGetReviewListProps,
): Promise<Blob> => {
  const requestConfig = getAuthenticatedRequestConfig({
    url: reviewListApiConfig.exportReviewList,
    method: AllowedHttpMethods.get,
    params: {
      activecycleId: props.cycleId,
      empStatus: props.empStatus,
      departmentName: props.departmentName,
      designationName: props.designationName,
      appraisalFormStatus: props.appraisalFormStatus,
      status: props.role,
      search: props.searchString,
      ratings: props.ratings.join(','),
      fromDate: props.fromDate ?? '',
      toDate: props.toDate ?? '',
      token: localStorage.getItem('token') ?? '',
      country: props.country,
      employmentType: props.employmentType,
    },
    responseType: 'blob',
  })

  const response = await useAxios(requestConfig)
  return response.data
}

const ReviewListApi = {
  getActiveCycle,
  getCycles,
  getDesignations,
  getReviewList,
  exportReviewList,
}

export default ReviewListApi
